import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';

// obtener Data libro Contable
export async function fetchReportContactsMails({ commit, state }) {
    //console.log(state.params);
    await $http.get('/api/envio-masivo-correos', { params: state.params })
        .then((response) => {
            //console.log(response.data.data);
            commit('setcontacts_mails', response.data);
            state.loading.module = false;
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: 'Error',
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}


export async function setContactsMails({ commit, state }, contacs_selected) {

    commit('setcontacts_mails_send', contacs_selected);

}

export async function updateTypeFormat({ commit, state }, type_format) {

    commit('setupdate_mails_send', type_format);

}

export async function fetchSellers({commit, state}, text) {
    let params = { filter:text}
    console.log(new Date()+"Empezando Sellers");
    await $http.get('/api/lista-vendedores', {params} )
        .then((response) => {
            commit('setSellers', response.data.data)
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box',
        });
    })
  }

export async function sendEmailMasive({ commit, state }, mails) {
    await $http.post('/api/enviando-masivo-correos', { params: mails })
        .then((response) => {
            commit('setcontacts_mails_send_reset');
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: 'Error',
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}

export async function printInforme({ commit, state },data) {
    let name = '';
    let url = '';
    if(state.params.type_format === 1){
        name = 'Informe Estado de Cuenta '+data.complete_name+'-'+data.identification+'.pdf'
        url ='/api/descargar-cartera/' + data.contact_id
    }else if(state.params.type_format === 2){
        name = 'Informe Aviso Reporte Negativo '+data.complete_name+'-'+data.identification+'.pdf'
        url ='/api/descargar-negativo/' + data.contact_id
    }else if(state.params.type_format === 3){
        name = 'Informe Aviso Cobre Juridico '+data.complete_name+'-'+data.identification+'.pdf'
        url ='/api/descargar-juridico/' + data.contact_id
    }


  await $http({
    url: url,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  }).catch((error) => {
    Notification.error({
      title: 'Error!',
      message: error.message,
      type: 'error',
      duration: 3000,
      customClass: 'notification-box',
    });

  })
}

export async function getSubscriber({ commit }) {

    const user = JSON.parse(localStorage.getItem('user'))
    const subscriber_id = user.subscriber_id

    await $http.get("/api/suscriptores/" + subscriber_id)
        .then(response => {

            const subscriber = response.data.data

            commit('setSubscriber', subscriber)

            if (subscriber.document) {
                commit('setParamsYearMonth', subscriber.document.document_date.substring(0, 9))
            }
        })
}

export async function addNotification({state, commit, rootState}, notification) {

    let notifications = rootState.Notifications.notifications

    const today = new Date();

    const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

    let new_notification = {
      id: null,
      title: 'ACTUALIZACIÓN MASIVA CARTERA',
      text: [
        {key: 'Fecha', value: date + ' ' + time},
        {key: 'Mensaje', value: notification.message}
      ],
      type: 'update_balances',
      url: null,
      close: true
    }

    notifications.unshift(new_notification)

    commit('Notifications/setNotifications', notifications, {root: true})
  }



// WEBPACK FOOTER //
// ./src/modules/masive-mails/actions.js